var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"info-answer-text ordered-item"},[_c('span',{staticClass:"text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }